import api from '@utils/api';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import customEventBus from 'src/scripts/libs/eventBus';
import bagSlice from './bag.slice';
import { BagActionTypes } from './common.types';
function* handleFetchBag(action) {
    var _a;
    let modified = true;
    let bag = yield call(api.getFullCart);
    // no, this should be done in the backend, not here
    // for (const item of bag.items) {
    //   // The minimum ATS for each variant of the product (color, size...)
    //   const minAts = Math.min(...item?.variationAttributes?.map((va) => va.ats));
    //   if (item.quantity > minAts) {
    //     // Can't purchase the selected quantity. Remove the excess and proceed.
    //     yield put(bagSlice.actions.setRemovedSoldOutProducts(true));
    //     yield call(api.removeFromBag, item.id, item.lineUUID);
    //     modified = true;
    //     // If some stock is left, add back the items up to the maximum quantity allowed.
    //     if (minAts > 0) {
    //       yield call(api.addToBag, item.id, minAts);
    //     }
    //   }
    // }
    if (modified) {
        bag = yield call(api.getFullCart);
        if (!((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.fromMinicart)) {
            customEventBus.emit('minicart:update', {});
        }
    }
    customEventBus.emit('cartCookie:update', {});
    yield put(bagSlice.actions.updateBag(bag));
}
function* handleUpdateProductSize(action) {
    const productId = action.payload.productId;
    const oldSizeId = action.payload.oldSizeId;
    const newSizeId = action.payload.newSizeId;
    const quantity = action.payload.quantity;
    if (!productId.endsWith(oldSizeId)) {
        // TODO: This should never happen!
        return;
    }
    const genericProductId = productId.slice(0, productId.length - oldSizeId.length);
    const newProductId = genericProductId + newSizeId;
    let cartResponse = yield call(api.addToBag, newProductId, quantity, productId);
    if (!cartResponse.error) {
        yield handleFetchBag();
    }
    else {
        yield put(bagSlice.actions.setMessage(cartResponse.message));
    }
}
function* handleAddPromoCode(action) {
    yield put(bagSlice.actions.resetPromoCodeError());
    const data = yield call(api.addPromoCode, action.payload);
    if ((data === null || data === void 0 ? void 0 : data.error) === true) {
        yield put(bagSlice.actions.setPromoCodeError(data.errorMessage));
        return;
    }
    yield handleFetchBag();
}
function* handlePromoCodeRemove(action) {
    yield put(bagSlice.actions.resetPromoCodeError());
    const data = yield call(api.promocodeRemove, action.payload);
    if ((data === null || data === void 0 ? void 0 : data.error) === true) {
        yield put(bagSlice.actions.setPromoCodeError(data.errorMessage));
        return;
    }
    yield handleFetchBag();
}
function* handleIncreaseQuantity(action) {
    yield put(bagSlice.actions.startUpdatingQuantity());
    yield call(api.addToBag, action.payload.pid, 1);
    yield handleFetchBag();
    yield put(bagSlice.actions.stopUpdatingQuantity());
}
function* handleDecreaseQuantity(action) {
    yield put(bagSlice.actions.startUpdatingQuantity());
    // This should not work... but it does.
    // TODO: (emi) Create a real API method to decrease cart quantity by one.
    yield call(api.addToBag, action.payload.pid, -1);
    yield handleFetchBag();
    yield put(bagSlice.actions.stopUpdatingQuantity());
}
function* handleRemoveProduct(action) {
    yield call(api.removeFromBag, action.payload.pid, action.payload.uuid);
    yield handleFetchBag();
}
function* watchFetchRequest() {
    yield takeEvery(BagActionTypes.FETCH_BAG, handleFetchBag);
    yield takeEvery(BagActionTypes.UPDATE_PRODUCT_SIZE, handleUpdateProductSize);
    yield takeEvery(BagActionTypes.REMOVE_PRODUCT_FROM_BAG, handleRemoveProduct);
    yield takeEvery(BagActionTypes.INCREASE_QUANTITY, handleIncreaseQuantity);
    yield takeEvery(BagActionTypes.DECREASE_QUANTITY, handleDecreaseQuantity);
    yield takeEvery(BagActionTypes.ADD_PROMO_CODE, handleAddPromoCode);
    yield takeEvery(BagActionTypes.PROMOCODE_REMOVE, handlePromoCodeRemove);
}
export default function* bagSaga() {
    yield all([fork(watchFetchRequest)]);
}
